import axios from 'axios';

const buildAuthConfig = rootState => ({
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${rootState.authorization.credential.token}`,
    },
});

const notifyRequestError = (commit, error) => {
    commit(
        'common/setNotification',
        {
            value: error,
            type: 'error',
        },
        {root: true},
    );
};

const mutations = {
    setLoadCountries: (state, data) => {
        state.countries = data;
    },
    setDebitCards: (state, data) => {
        state.debitCards = data;
    },
    setRubAmount: (state, data) => {
        state.rubAmount = data;
    },
    setProcessing: (state, processing) => {
        state.processing = processing;
    },
};

const actions = {
    outputSum: ({ commit, rootState }, data) => {
        commit('setProcessing', true);

        return axios.post(
            '/rest/market/payout/request', data, buildAuthConfig(rootState),
        )
            .then()
            .catch(error => notifyRequestError(commit, error))
            .finally(() => {
                commit('setProcessing', false);
            });
    },
    getCountries: ({ commit, rootState }, data) => {
        const query = data ? `?q=${data}` : '';

        return axios
            .get(`/rest/market/payout/countries${query}`, buildAuthConfig(rootState))
            .then(response => {
                commit('setLoadCountries', response.data);
            })
            .catch(error => notifyRequestError(commit, error));
    },
    getDebitCards: ({ commit, rootState }) => axios
        .get('/rest/market/payout/cards', buildAuthConfig(rootState))
        .then(response => {
            commit('setDebitCards', response.data.data || []);
        })
        .catch(error => notifyRequestError(commit, error)),
    createDebitCard: ({ commit, rootState }, data) => {
        commit('setProcessing', true);

        return axios.post(
            '/rest/market/payout/createCard', data, buildAuthConfig(rootState),
        )
            .then(response => response)
            .catch(error => notifyRequestError(commit, error))
            .finally(() => {
                commit('setProcessing', false);
            });
    },
    deleteDebitCard: ({ commit, rootState }, debitCardId) => {
        commit('setProcessing', true);

        return axios.post(
            '/rest/market/payout/deleteCard', {debitCardId}, buildAuthConfig(rootState),
        )
            .then(response => response)
            .catch(error => notifyRequestError(commit, error))
            .finally(() => {
                commit('setProcessing', false);
            });
    },
    getConvertSum: ({ commit, rootState }, data) => axios
        .get(`/rest/market/payout/convert?coins=${data}`, buildAuthConfig(rootState))
        .then(response => {
            commit('setRubAmount', parseFloat(response.data.rubAmount).toFixed(2));
        })
        .catch(error => notifyRequestError(commit, error)),
};
const state = {
    countries: [],
    debitCards: [],
    rubAmount: 0,
    processing: false,
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
};
